import {
  canBuy,
  effectiveMaxLevel,
  itemCost,
  itemUnlocked,
  ownedLevel,
  SHOP,
  type EconomyState,
} from '../core/economy';

const COLORS = {
  bg: '#13162b',
  text: '#c8d0f0',
  dim: '#6b76a8',
  sel: '#ffffff',
  gold: '#f2c94c',
  ok: '#9bbc0f',
};

/** Render the upgrade shop: wallet, item list with cost/owned, selection + hints. */
export function renderShop(
  ctx: CanvasRenderingContext2D,
  viewW: number,
  viewH: number,
  economy: EconomyState,
  selected: number,
  completedZones: ReadonlySet<string>,
): void {
  ctx.fillStyle = COLORS.bg;
  ctx.fillRect(0, 0, viewW, viewH);

  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  ctx.fillStyle = COLORS.text;
  ctx.font = '14px monospace';
  ctx.fillText('SHOP', 16, 10);
  ctx.fillStyle = COLORS.gold;
  ctx.font = '11px monospace';
  ctx.fillText(`● ${economy.wallet.coins}   ◆ ${economy.wallet.diamonds}`, 120, 13);

  const zonesCleared = completedZones.size;
  ctx.font = '11px monospace';
  SHOP.forEach((item, i) => {
    const y = 40 + i * 22;
    const lvl = ownedLevel(economy, item.id);
    const cap = effectiveMaxLevel(item, zonesCleared);
    const maxed = lvl >= cap;
    const cost = itemCost(item, lvl);
    const unlocked = itemUnlocked(item, completedZones);
    const affordable = unlocked && canBuy(economy, item, zonesCleared);
    ctx.fillStyle = i === selected ? COLORS.sel : unlocked ? COLORS.text : COLORS.dim;
    ctx.fillText(`${i === selected ? '>' : ' '} ${item.name}  (${lvl}/${cap})`, 16, y);

    let costText: string;
    let costColor: string;
    if (!unlocked) {
      costText = `clear the ${item.unlockZone}`;
      costColor = COLORS.dim;
    } else if (maxed) {
      // Scaling tuners can still grow when more zones are cleared.
      costText = item.scaleWithZones && cap < item.maxLevel ? 'clear a zone to raise cap' : 'MAX';
      costColor = COLORS.ok;
    } else {
      const parts: string[] = [];
      if (cost.coins) parts.push(`● ${cost.coins}`);
      if (cost.diamonds) parts.push(`◆ ${cost.diamonds}`);
      costText = parts.join('  ') || 'free';
      costColor = affordable ? COLORS.gold : COLORS.dim;
    }
    ctx.fillStyle = costColor;
    ctx.fillText(costText, 230, y);
  });

  ctx.fillStyle = COLORS.text;
  ctx.fillText('↑/↓ select   Space buy   Esc back', 16, viewH - 18);
}
